import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bbb55a1&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbb55a1')) {
      api.createRecord('2bbb55a1', component.options)
    } else {
      api.reload('2bbb55a1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2bbb55a1&", function () {
      api.rerender('2bbb55a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inspection/confirmed/index.vue"
export default component.exports